import { HIDE_HOW_IT_WORK_BANNER } from '../actions/current-user-data';

const initialState = {
  showHowItWorkBanner: true,
};

/**
 * A collections to handle data about current user information
 */
export default (state = initialState, action) => {
  switch (action.type) {
    case HIDE_HOW_IT_WORK_BANNER:
      return {
        ...state,
        showHowItWorkBanner: false,
      };

    default:
      return state;
  }
};
